// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + (chunkId === "460" ? "quickjs-sandbox" : chunkId) + "." + {"396": "c117b6a7cfbc55f7","460": "65ebb599dfcd0c11","917": "9300ce41999d5d2f","985": "05d195d46238bee0",}[chunkId] + ".chunk.js"
}